import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4dbe300e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate channel-header-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "animate modal"
}
const _hoisted_4 = { class: "modal-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Editar Nickname", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  key: 2,
  class: "animate modal"
}
const _hoisted_11 = { class: "modal-inner" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Editar Portada", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "La imagen de portada cubrirá toda la zona de presentación, escalando escalando en formato 'cover' para cubrir el área. El tamaño máximo de imagen permitido es de 4Mbb.", -1))
const _hoisted_14 = { class: "animate profile-name" }
const _hoisted_15 = { class: "animate reputation-card" }
const _hoisted_16 = { class: "animate profile-image-container" }
const _hoisted_17 = { class: "animate profile-image" }
const _hoisted_18 = { class: "animate profile-data-container" }
const _hoisted_19 = {
  class: "animate profile-data",
  style: {"background-color":"#333"}
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }

import ProfileImage from '@/components/widgets/ProfileImage.vue';
import ReputationCardUsers from '@/components/widgets/ReputationCardUsers.vue';
import ChannelService from '@/services/ChannelService';
import ProfileService from '@/services/ProfileService';
import { ref, onMounted } from 'vue'
import { useAuth } from '@/store/useAuth';
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import router from '@/router';
import FollowChannelButton from '@/components/widgets/FollowChannelButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditChannelHeader',
  setup(__props) {

const channelService = new ChannelService()
const user = ref()
const loading = ref(true)
const profileService = new ProfileService()
const store = useAuth()
const showEditNickname = ref(false)
const nickname = ref('')
const toast = useToast()
const bg = ref()
const showUpdateBG = ref(false)
const feedback = ref('')
const followers = ref()
const following = ref()

onMounted(async () => {
    if (!store.token) { return }
    loading.value = true
    user.value = await profileService.MyUser(store.token)
    followers.value = await channelService.CountFollowers(user.value.id)
    following.value = await channelService.CountFollowing(user.value.id)
    loading.value = false
})

const onFileChange = (event) => {
    const file = event.target.files[0];
    bg.value = file;
};

const handleNickname = async () => {
    if (!store.token) { return }

    if ((nickname.value.length < 4) || (!validateNickname(nickname.value))) {
        toast.showToast("Nombre no válido. Utiliza caracteres no permitidos en el sistema.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    const response = await profileService.UpdateNickname(store.token, nickname.value.toLowerCase())
    if (response == true) {
        toast.showToast("Perfil actualizado.", Toast.SUCCESS)
        setTimeout(function () { toast.hideToast() }, 4000);
        showEditNickname.value = false
        user.value = await profileService.MyUser(store.token)
        return;
    }

    toast.showToast("El usuario ya existe en el sistema.", Toast.DANGER)
    setTimeout(function () { toast.hideToast() }, 4000);
}

const handleBG = async () => {
    if (!store.token) { return }
    feedback.value = "Subiendo..."
    const response = await profileService.UpdateBG(store.token, bg.value)
    if (response.success == true) {
        toast.showToast("Perfil Actualizado", Toast.SUCCESS)
        setTimeout(function () { toast.hideToast() }, 4000);
        user.value = await profileService.MyUser(store.token)
        showUpdateBG.value = false
        feedback.value = ""
    } else {
        toast.showToast(response.message, Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        feedback.value = ""
    }
}

const validateNickname = (n: string) => {
    const regex = /^[a-zA-Z0-9]+$/;
    return regex.test(n);
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_unref(store).token && !loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (user.value.profile_bg_uri)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: user.value.profile_bg_uri,
              class: "bg-image"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (showEditNickname.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  style: {"float":"right","cursor":"pointer"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showEditNickname.value = false))
                }, [
                  _createVNode(_component_v_icon, {
                    name: "ri-close-circle-fill",
                    fill: "lightcoral"
                  })
                ]),
                _hoisted_5,
                _createElementVNode("p", null, [
                  _createTextVNode("El Nickname debe ser único en la plataforma, y te permitirá disponer de una URL personalizada para tu canal, que será:"),
                  _hoisted_6,
                  _hoisted_7,
                  _createElementVNode("b", null, "https://campus-ademass.com/c/" + _toDisplayString(nickname.value.toLowerCase()), 1),
                  _hoisted_8,
                  _hoisted_9,
                  _createTextVNode("para que puedas compartirla más fácilmente. Evita usar espacios en blanco y caracteres especiales.")
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "input-text",
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nickname).value = $event)),
                  placeholder: "Nuevo Nickname"
                }, null, 512), [
                  [_vModelText, nickname.value]
                ]),
                _createElementVNode("button", {
                  class: "new-question",
                  onClick: handleNickname
                }, "Actualizar Nickname")
              ])
            ]))
          : _createCommentVNode("", true),
        (showUpdateBG.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  style: {"float":"right","cursor":"pointer"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showUpdateBG.value = false))
                }, [
                  _createVNode(_component_v_icon, {
                    name: "ri-close-circle-fill",
                    fill: "lightcoral"
                  })
                ]),
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("input", {
                  class: "input-text",
                  type: "file",
                  onChange: onFileChange,
                  placeholder: "Nueva Portada"
                }, null, 32),
                _createElementVNode("button", {
                  class: "new-question",
                  onClick: handleBG
                }, "Actualizar Portada"),
                _createElementVNode("small", null, _toDisplayString(feedback.value), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "edit-bg-image",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showUpdateBG.value = true))
        }, [
          _createVNode(_component_v_icon, {
            class: "pencil-2",
            name: "bi-pencil-fill",
            style: {"overflow-y":"hidden"}
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("h3", null, [
            _createTextVNode(_toDisplayString(user.value.name), 1),
            _createVNode(_component_v_icon, {
              class: "pencil-2",
              name: "bi-pencil-fill",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push({ name: 'profile' })))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(ReputationCardUsers, {
            user_id: user.value.id
          }, null, 8, ["user_id"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(ProfileImage)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (user.value.nickname)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_20, [
                    _createTextVNode("@" + _toDisplayString(user.value.nickname) + " ", 1),
                    _createVNode(_component_v_icon, {
                      class: "pencil",
                      name: "bi-pencil-fill",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showEditNickname.value = true))
                    })
                  ]))
                : (_openBlock(), _createElementBlock("h5", _hoisted_21, [
                    _createTextVNode("@" + _toDisplayString(user.value.name.substring(0, 3) + user.value.id) + " ", 1),
                    _createVNode(_component_v_icon, {
                      class: "pencil",
                      name: "bi-pencil-fill",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (showEditNickname.value = true))
                    })
                  ]))
            ]),
            (user.value.nickname)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "animate profile-data",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(router).push({name: 'followers-list', params: {nickname: user.value.nickname}})))
                }, [
                  _createElementVNode("h5", null, "Seguidores: " + _toDisplayString(followers.value), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "animate profile-data",
                  style: {"cursor":"pointer"},
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(router).push({name: 'followers-list', params: {nickname: user.value.name.substring(0, 3) + user.value.id}})))
                }, [
                  _createElementVNode("h5", null, "Seguidores: " + _toDisplayString(followers.value), 1)
                ])),
            (user.value.nickname)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "animate profile-data",
                  style: {"cursor":"pointer"},
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(router).push({name: 'following-list', params: {nickname: user.value.nickname}})))
                }, [
                  _createElementVNode("h5", null, "Siguiendo: " + _toDisplayString(following.value), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "animate profile-data",
                  style: {"cursor":"pointer"},
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(router).push({name: 'following-list', params: {nickname: user.value.name.substring(0, 3) + user.value.id}})))
                }, [
                  _createElementVNode("h5", null, "Siguiendo: " + _toDisplayString(following.value), 1)
                ])),
            _createVNode(FollowChannelButton, {
              user_id: user.value.id
            }, null, 8, ["user_id"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})